module.exports = __webpack_public_path__ + "assets/scoober-logo-en-a5c003.svg";